import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useRef, useState, useCallback, useContext } from 'react';
import { throttle } from 'throttle-debounce';
import { TABLE_HEAD } from '../../utils/TableSectionContext';
import { TableContext } from '../../utils/TableContext';
import { TABLE_THROTTLE_PERIOD } from '../../constants';
import { useInternalRef } from '../../../../utils';
import { getWindow } from '../../../../system/util/getWindow';
export var useTableHead = function useTableHead(_ref) {
  var ref = _ref.ref;
  var tableContextValue = useContext(TableContext);
  var stickyHead = tableContextValue.data.stickyHead,
      updateTableContext = tableContextValue.update;

  var _useState = useState({
    data: {
      section: TABLE_HEAD
    }
  }),
      _useState2 = _slicedToArray(_useState, 1),
      tableSectionContextValue = _useState2[0];

  var rootReference = useRef();
  useInternalRef(ref, rootReference);
  var onLayoutUpdate = useCallback(throttle(TABLE_THROTTLE_PERIOD, false, function () {
    if (!stickyHead) {
      return;
    }

    if (rootReference.current) {
      var firstCell = rootReference.current.querySelector('th');

      if (!firstCell) {
        return;
      }

      var headerTop = rootReference.current.getBoundingClientRect().top;
      var cellTop = firstCell.getBoundingClientRect().top;
      var differentLevels = headerTop !== cellTop;

      if (tableContextValue.data.stickyHeadVisible !== differentLevels) {
        updateTableContext(_objectSpread(_objectSpread({}, tableContextValue), {}, {
          data: _objectSpread(_objectSpread({}, tableContextValue.data), {}, {
            stickyHeadVisible: differentLevels
          })
        }));
      }
    }
  }), []);
  useEffect(function () {
    var win = getWindow();

    if (win) {
      win.addEventListener('resize', onLayoutUpdate);
      win.addEventListener('scroll', onLayoutUpdate);
    }

    return function () {
      if (win) {
        win.removeEventListener('resize', onLayoutUpdate);
        win.removeEventListener('scroll', onLayoutUpdate);
      }
    };
  }, [onLayoutUpdate]);
  return {
    tableSectionContextValue: tableSectionContextValue,
    rootReference: rootReference
  };
};